<template>
  <section v-if="data?.models || list">
    <div id="projects" class="pd70">
      <div class="wrapper w1200">
        <UiAnim tag="h2" class="block_title"
          >Примеры выполненных нами проектов</UiAnim
        >

        <div id="projects_nav" v-if="data?.models?.length">
          <UiAnim
            type="t-30"
            v-for="(m, i) in data.models"
            :key="i"
            class="projects_item"
          >
            <a
              :href="`/projects/avto/${m.url}`"
              @click.prevent="goto(m)"
              :class="{ active: active == m.id }"
            >
              {{ m.title }}</a
            ></UiAnim
          >
          <span class="clr"></span>
        </div>

        <template v-if="list?.length">
          <ul id="projects-link">
            <UiAnim
              tag="li"
              v-for="(p, i) in list"
              :key="p.id"
              :class="{ even: i % 2 == 0, odd: i % 2 != 0 }"
              :type="`${i % 2 == 0 ? 'lr' : 'rl'}-100`"
            >
              <NuxtLink :to="`/projects/${p.url}-${p.id}`">
                <div class="content">
                  <UiLazyImg
                    v-if="p.preview_image"
                    :wrapAttr="{
                      class: 'image',
                    }"
                    :src="`/upload/image/${p.preview_image}/projects.jpg`"
                  />

                  <div class="text">
                    <h3>{{ p.title }}</h3>
                  </div>
                </div>
              </NuxtLink>
            </UiAnim>
          </ul>
          <span class="clr"></span>
        </template>
      </div>
    </div>
  </section>
</template>

<script setup>
/*
import { useWindowScroll } from "@vueuse/core";
import { useElementBounding } from "@vueuse/core";
import { useTemplateRef } from "vue";
const el = useTemplateRef("el");
*/

const props = defineProps(["data"]);
const list = ref(props.data.list || null);
const active = ref(props.data.active || 0);
const route = useRoute();
const goto = async (m) => {
  if (route.path != "/") return navigateTo(`/projects/avto/${m.url}`);
  //list.value = null;
  list.value = await $fetch(`/api/projects.list?id=${m.id}`);
  active.value = m.id;
  /*
  const { top } = useElementBounding(el);
  const { y } = useWindowScroll();
  const doc = document.documentElement;
  const t = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  y.value = top.value + t;
  */
};
</script>
